//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
export default {
  name: 'NsExpressiveLink',
  props: {
    /**
     * The highlight color after the link is hovered. Can be a named color, a
     * hex value, a RGB value or even a css variable
     */
    afterColor: {
      type: String,
      default: '',
    },
    /**
     * The highlight color before the link is hovered Can be a named color, a
     * hex value, a RGB value or even a css variable
     */
    beforeColor: {
      type: String,
      default: '',
    },
    /**
     * Where the link takes the user when clicked
     */
    href: {
      type: String,
      default: '',
    },
    /**
     * Alters the colors for a dark background
     */
    invert: Boolean,
    /**
     * The target of the <a> tag
     */
    target: {
      type: String,
      default: '_self',
    },
  },
  data() {
    return {
      animationState: '',
    };
  },
  computed: {
    dynamicStyle() {
      return {
        '--expressive-link-bg-1-transparent': this.beforeColor,
        '--expressive-link-bg-2-transparent': this.afterColor,
      };
    },
  },
  methods: {
    /**
     * Animates the highlight in
     */
    addAnimateIn() {
      this.animationState = 'animate-in';
    },
    /**
     * Animates the highlight out
     */
    addAnimateOut() {
      this.animationState = 'animate-out';
    },
    /**
     * If no href, emits a click event
     */
    handleClick(event) {
      if (!this.href) {
        event.preventDefault();
        this.$emit('click', event);
      }
    },
  },
};
